import { Link } from "@/i18n/LocaleLink";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useContent } from "@/data/content";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  const { ui } = useContent();
  const nf = ui.notFound;
  useSeo({ title: nf.title, description: nf.body, noindex: true });
  return (
    <main className="bg-cream min-h-screen" data-testid="not-found-page">
      <section className="mx-auto max-w-2xl px-6 pt-48 pb-32 text-center">
        <Reveal>
          <p className="font-serif italic text-7xl text-clay/40" aria-hidden>404</p>
          <h1 className="mt-8 font-serif text-4xl sm:text-5xl tracking-tight text-ink" data-testid="not-found-title">{nf.title}</h1>
          <p className="mt-6 text-base leading-relaxed text-soft" data-testid="not-found-body">{nf.body}</p>
          <Link
            to="/"
            data-testid="not-found-home"
            className="group mt-10 inline-flex items-center gap-3 rounded-full bg-clay px-8 py-4 text-sm tracking-wide text-cream transition-colors duration-300 hover:bg-rust"
          >
            {nf.cta}
            <ArrowRight size={16} strokeWidth={1.5} className="transition-transform duration-300 group-hover:translate-x-1" />
          </Link>
        </Reveal>
      </section>
    </main>
  );
}
